import IdemiaCard from './IdemiaCard';

export default IdemiaCard;
